import $api from "../http"

export default class FilesService{
    static fetchFiles(user_id,parent_id,onbasket){
        return $api.post('/files/get',{ user_id,parent_id,onbasket })
    }
    static createDir(user_id,name,type,parent_id){
        return $api.post('/files/dir',{ user_id,name,type,parent_id })
    }
    static fetchAllFiles(user_id){
        return $api.post('/files/getall',{ user_id })
    }
    static getPath(parent){
        return $api.post('/files/getpath',{ parent })
    }

    static loadImage(file,path = 'news'){ //,
        if(file){
            if(this.isImage(file.name)){
                const formData = new FormData()
                formData.append('file', file)
                formData.append('filename', file.name)
                formData.append('path', path)
                return $api.post('/files/loadimg',formData)
            }else{
                return {err:true,message:'Файл не является изображением'}
            }
        }else{
            return {err:false,message:'Файл не выбран'}
        }
    }
    static loadAvatarImage(file){ //,
        if(file){
            if(this.isImage(file.name)){
                const formData = new FormData()
                formData.append('file', file)
                formData.append('filename', file.name)
                return $api.post('/files/loadavatarimg',formData)
            }else{
                return {err:true,message:'Файл не является изображением'}
            }
        }else{
            return {err:false,message:'Файл не выбран'}
        }
    }

    static loadPollsImage(file){
        if(file){
            if(this.isImage(file.name)){
                const formData = new FormData()
                formData.append('file', file)
                formData.append('filename', file.name)
                return $api.post('/files/loadpollsimg',formData)
            }else{
                return {err:true,message:'Файл не является изображением'}
            }
        }else{
            return {err:false,message:'Файл не выбран'}
        }
    }
    static isImage(filename) {
        const imageExtensions = ['jpg', 'jpeg', 'png', 'gif', 'bmp']; // расширения изображений
        const extension = filename.split('.').pop().toLowerCase(); // получаем расширение файла и приводим его к нижнему регистру
        return imageExtensions.includes(extension); // возвращаем true, если расширение файла соответствует расширениям изображений
    }
    static isDocuments(filename) {
        const documentsExtensions = ['doc', 'docx', 'pdf', 'xls', 'xlsx', 'jpg', 'jpeg', 'png', 'gif', 'bmp', 'heic','zip','rar']
        const extension = filename.split('.').pop().toLowerCase()
        return documentsExtensions.includes(extension)
    }
    static uploadFile(file,user_id,parent_id,onUploadProgress ){
        const formData = new FormData()
        formData.append('file', file)
        formData.append('parent', parent_id)
        formData.append('user', user_id)
        formData.append('filename', file.name)

        if(file.size > 2147483648) return {message: 'Слишком большой размер брат.'}

        return $api.post('/files/upload',formData,{
            onUploadProgress: onUploadProgress
        })
    }
    static uploadTaskFiles(file,onUploadProgress ){
        if(file){
            if(this.isDocuments(file.name)){
                const formData = new FormData()
                formData.append('file', file)
                formData.append('filename', file.name)
                if(file.size > 2147483648) return {message: 'Слишком большой размер брат.'}
                return $api.post('/files/uploadfile',formData,{
                    onUploadProgress: onUploadProgress
                })
            }
        }
    }
    static uploadTempFiles(file,onUploadProgress ){
        if(file){
            if(this.isDocuments(file.name)){
                const formData = new FormData()
                formData.append('file', file)
                formData.append('filename', file.name)
                if(file.size > 2147483648) return {message: 'Слишком большой размер брат.'}
                return $api.post('/files/uploadtempfile',formData,{
                    onUploadProgress: onUploadProgress
                })
            }
        }
    }

    static uploadCrewFile(file,crew){
        if(file){
            if(this.isDocuments(file.name)){
                const formData = new FormData()
                formData.append('file', file)
                formData.append('crew', crew.id)
                formData.append('filename', file.name)
                if(file.size > 2147483648) return {message: 'Слишком большой размер брат.'}
                return $api.post('/files/uploadcrewfile',formData)
            }
        }
    }
    static getCrewFiles(id){
        return $api.post('/files/getcrewfiles',{id})
    }
    static deleteCrewFile(file,crew){
        return $api.post('/files/deletecrewfiles',{file,crew})
    }

    static uploadGalaryFiles(file,onUploadProgress ){
        if(file){
            if(this.isDocuments(file.name)){
                const formData = new FormData()
                formData.append('file', file)
                formData.append('filename', file.name)
                if(file.size > 2147483648) return {message: 'Слишком большой размер брат.'}
                return $api.post('/files/uploadcover',formData,{
                    onUploadProgress: onUploadProgress
                })
            }
        }
    }
    static downloadCrewFile(file){
        return $api.post(`/files/downloadcrewfile`, {file},{responseType:'blob'})
    }

    static uploadGalaryDocs(file,onUploadProgress ){
        if(file){
            if(this.isDocuments(file.name)){
                const formData = new FormData()
                formData.append('file', file)
                formData.append('filename', file.name)
                if(file.size > 2147483648) return {message: 'Слишком большой размер брат.'}
                return $api.post('/files/uploaddocs',formData,{
                    onUploadProgress: onUploadProgress
                })
            }
        }
    }

    static createAlbum(album){
        return $api.post('/files/newalbum',{album})
    }

    static makeListImgs(list){
        return $api.post('/files/makelistimgs',{list})
    }

    static makeListDocs(list){
        return $api.post('/files/makelistdocs',{list})
    }

    static getAlbum(id){
        return $api.post('/files/getalbum',{id})
    }
    static getListFromAlbum(id){
        return $api.post('/files/getlistfromalbum',{id})
    }
    static deleteFile(name){
        return $api.post('/files/deletefile',{name})
    }
    static fetchStatements(){
        return $api.get('/files/getstatements')
    }
    static downloadStatement(id){
        return $api.post('/files/downloadstatement',{id},{responseType:'blob'})
    }
    static downloadFile(id){
        return $api.post('/files/downloadfile',{id},{responseType:'blob'})
    }
    static downloadMessageFile(chat,id){
        return $api.post('/files/downloadmessagefile',{chat,id},{responseType:'blob'})
    }
    static fileToTrash(id){
        return $api.post('/files/filetotrash',{ id })
    }
    static fileFromTrash(id){
        return $api.post('/files/filefromtrash',{ id })
    }
    static getAllAlbums(){
        return $api.get('/files/getallalbums')
    }

    static sendDocsToGalary(files){
        return $api.post('/files/senddocstogalary',{files})
    }
    static DocsAlbum(id){
        return $api.post('/files/docalbum', {id})
    }
    static sendCommGalary(comm){
        return $api.post('/files/sendcommgalary', {comm})
    }
    static allCommGalary(id){
        return $api.post('/files/allcommgalary', {id})
    }
    static allCommImg(img){
        return $api.post('/files/allcommimg', {img})
    }
    static sendCommImg(comm){
        return $api.post('/files/sendcommimg', {comm})
    }

    static plusLikeGalary(like){
        return $api.post('/files/pluslikegalary', {like})
    }
    static plusLikeAlbum(like){
        return $api.post('/files/pluslikealbum', {like})
    }



}
